// src/app/store.js
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import authReducer, { setCredentials } from "features/auth/authSlice";
import callApplicationReducer from "features/callApplicationSlice/callApplicationSlice";
import languageReducer from "features/language/languageSlice";

import { activeCaseApi } from "components/services/active-case/ActiveCaseService";
import { applicationApi } from "components/services/application/ApplicationService"; // Import the applicationApi
import { fileApi } from "components/services/application-file/ApplicationFile";
import { authApi } from "components/services/authorization/authService";
import { bankApi } from "components/services/bank/bankService";
import { callApplicationApi } from "components/services/call-application/CallApplicationService";
import { callApplicationFileApi } from "components/services/call-application-file/CallApplicationFile";
import { commentApi } from "components/services/comment/commentService";
import { contactInformationApi } from "components/services/contact-information/ContactInformationService";
import { feedbackApi } from "components/services/feedback/feedbackService";
import { messagesApi } from "components/services/messages/messagesService";
import { reportApi } from "components/services/report/reportService";
import { reportScheduleApi } from "components/services/report-schedule/reportScheduleService";
import { templateCommentApi } from "components/services/template-comment/templateCommentService";
import { templateFileApi } from "components/services/template-file/templateFileService";
import { userApi } from "components/services/users/userService";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    language: languageReducer,
    callApplication: callApplicationReducer,
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [fileApi.reducerPath]: fileApi.reducer,
    [callApplicationFileApi.reducerPath]: callApplicationFileApi.reducer,
    [callApplicationApi.reducerPath]: callApplicationApi.reducer,
    [applicationApi.reducerPath]: applicationApi.reducer,
    [commentApi.reducerPath]: commentApi.reducer,
    [contactInformationApi.reducerPath]: contactInformationApi.reducer,
    [templateCommentApi.reducerPath]: templateCommentApi.reducer,
    [feedbackApi.reducerPath]: feedbackApi.reducer,
    [messagesApi.reducerPath]: messagesApi.reducer,
    [reportScheduleApi.reducerPath]: reportScheduleApi.reducer,
    [bankApi.reducerPath]: bankApi.reducer,
    [templateFileApi.reducerPath]: templateFileApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [activeCaseApi.reducerPath]: activeCaseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      userApi.middleware,
      callApplicationApi.middleware,
      applicationApi.middleware,
      fileApi.middleware,
      callApplicationFileApi.middleware,
      commentApi.middleware,
      contactInformationApi.middleware,
      templateCommentApi.middleware,
      feedbackApi.middleware,
      messagesApi.middleware,
      reportScheduleApi.middleware,
      bankApi.middleware,
      templateFileApi.middleware,
      reportApi.middleware,
      activeCaseApi.middleware
    ),
});

const user = localStorage.getItem("user");
const accessToken = localStorage.getItem("accessToken");

if (user && accessToken) {
  store.dispatch(setCredentials({ user: JSON.parse(user), accessToken }));
}

// Optional: setup listeners for refetching queries on focus/reconnect
setupListeners(store.dispatch);
